module.exports = __webpack_public_path__ + "img/GH-kyujin-top-037.ae8496ac.webp";